export const GET_CATEGORY = "GET_CATEGORY";
export const CREATE_NEW_CATEGORY = "CREATE_NEW_CATEGORY";
export const EDIT_CATEGORY = "EDIT_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";

export const OPEN_CATEGORY_DIALOG = "OPEN_CATEGORY_DIALOG";
export const CLOSE_CATEGORY_DIALOG = "CLOSE_CATEGORY_DIALOG";
